import { FunctionComponent, useCallback } from 'react';

import { FeatureConfiguration } from '../../config/FeatureConfiguration';
import { Logger } from '../../logger/Logger';
import { useCoreDispatch } from '../../store/CoreStore';
import { useConfigSlice } from '../../store/slices/config/selectors';
import { useGameStateSlice } from '../../store/slices/game/selectors';
import { gameStateActions } from '../../store/slices/game/slice';
import { useHeaderSlice } from '../../store/slices/header/selectors';
import { headerActions } from '../../store/slices/header/slice';
import { TrafficLightConnected } from '../game/trafficLight/TrafficLightConnected';
import { L12nText } from '../text/L12nText';
import { useVideoRef } from '../video_v8/VideoRefContext';

import { BackToGame } from './BackToGame';

export const BackToGameConnected: FunctionComponent = () => {
  const dispatch = useCoreDispatch();
  const { videoRef } = useVideoRef();
  const tableName = useConfigSlice.tableName();
  const isLobbyOpen = useHeaderSlice.getIsMiniLobbyOpen();
  const isGameSuspended = useGameStateSlice.getIsGameSuspended();
  const lobbyVersion = useConfigSlice.casinoConfig()?.lobbyVersion;
  const poster = useGameStateSlice.getVideoPoster();
  const isBackToGameHidden = useHeaderSlice.getIsBackToGameHidden();

  const handleClick = useCallback((): void => {
    Logger.logEvent('backToGameClick');
    dispatch(headerActions.setOpenedModal(null));
    dispatch(headerActions.setNavRoute([]));
    dispatch(headerActions.setMiniLobbyOpen(false));
  }, [dispatch]);

  const handleCloseClick = useCallback((): void => {
    Logger.logEvent('backToGameClose');
    dispatch(gameStateActions.setGameSuspended(true));
  }, [dispatch]);

  if (lobbyVersion !== '2') return;
  return (
    <BackToGame
      name={tableName ? <L12nText tk={tableName} /> : undefined}
      actionLabel={<L12nText tk={'LOBBY_BACK_TO_GAME'} />}
      videoElement={FeatureConfiguration.isBackToGameVideoEnabled ? videoRef?.current : undefined}
      trafficLight={<TrafficLightConnected line />}
      isOpen={isLobbyOpen && !isGameSuspended}
      isHidden={isBackToGameHidden}
      onClick={handleClick}
      onClose={handleCloseClick}
      poster={poster}
    />
  );
};
